// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-CartTrigger__cartTrigger__root cmp-components__clickable__root"};